import { isObject } from 'lodash';
import type { ReadyMessage, SyncMessage } from './types';

export const isReadyMessage = (data: unknown): data is ReadyMessage =>
  isObject(data) && 'type' in data && data.type === 'ready';

export const isSyncMessage = (data: unknown): data is SyncMessage =>
  isObject(data) && 'type' in data && data.type === 'sync';
